/// <reference path="../../../../Scripts/TypeScript/angularjs/angular.d.ts"/>
/// <reference path="../../../../Scripts/TypeScript/umbrella/umbrella.d.ts"/>

namespace Umbrella.KCC.CaseFlowDashboard.Overview {
    angular.module('Dashboard').config([
        '$stateProvider',
        ($stateProvider: angular.ui.IStateProvider) => {
            $stateProvider.state('dashboard.caseflow.overview.details.steps', {
                url: '/stappen',
                data: {
                    pageTitle: 'Zaakstappen',
                    authorize: ps => [ps.viewCaseFlow, ps.viewDetailedCaseFlow]
                },
                views: {
                    tabcontent: {
                        template:
                            '<caseflow-details state="state$ | async:this"></caseflow-details>',
                        controller: Umbrella.createComponentRouteController<
                            CaseFlowState,
                            CaseFlowDetailsComponentState
                        >('CaseFlowOverviewStore', s => ({
                            case: s && s.caseInfo.caseflow,
                            caseHistory: s && s.caseInfo.caseHistory,
                            person: s && s.caseInfo.person,
                            mediaIds: s &&  s.caseInfo.media && s.caseInfo.media.map(m => m.mediaId)
                        }))
                    }
                }
            });
        }
    ]);
}
